import { Typography, TypographyProps } from '@mui/material';
import { CSSProperties, FunctionComponent, PropsWithChildren } from 'react';

import { useExtendedIntl } from 'hooks/useExtendedIntl';

interface ErrorMessageProps {
  className?: string;
  id?: string;
  style?: CSSProperties;
  values?: Record<string, string>;
}

export const ErrorMessage: FunctionComponent<PropsWithChildren<ErrorMessageProps & TypographyProps>> = ({
  className,
  id = 'shared.default-error-message',
  style,
  values,
  ...rest
}) => {
  const { formatMessage } = useExtendedIntl();

  return (
    <Typography className={className} style={style} {...rest} data-testid="error-message">
      {formatMessage({ id }, values)}
    </Typography>
  );
};
